module.exports = __webpack_public_path__ + "media/images/camera-6b2d2ebe8ba926bf6e6b95ee1fa75e3b.svg";